/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_Domain_BrandInputs */

const en_mapping_domain_brand = /** @type {(inputs: Mapping_Domain_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brands`)
};

/**
* | output |
* | --- |
* | "Brands" |
*
* @param {Mapping_Domain_BrandInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_domain_brand = /** @type {((inputs?: Mapping_Domain_BrandInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_Domain_BrandInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_domain_brand(inputs)
});